"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonConfirmNextSection = exports.buttonSaveTrip = exports.segmentHasNextMode = exports.tripJunctionGeography = exports.tripJunctionQueryString = exports.segmentOnDemandType = exports.segmentBusLinesWarning = exports.segmentBusLines = exports.segmentDriver = exports.segmentVehicleOccupancy = exports.segmentPaidForParking = exports.segmentHowToBus = exports.segmentMode = exports.segmentModePre = exports.segmentSameModeAsReverseTrip = exports.segments = exports.segmentIntro = exports.personTrips = exports.personVisitedPlacesMap = exports.segmentsPersonTripsTitle = exports.buttonSwitchPerson = exports.activePersonTitle = void 0;
const defaultInputBase = __importStar(require("evolution-frontend/lib/components/inputs/defaultInputBase"));
const validations = __importStar(require("evolution-common/lib/services/widgets/validations/validations"));
const choices = __importStar(require("../../common/choices"));
const customConditionals = __importStar(require("../../common/customConditionals"));
const customWidgets = __importStar(require("./customWidgets"));
const customChoices = __importStar(require("./customChoices"));
exports.activePersonTitle = customWidgets.activePersonTitle;
exports.buttonSwitchPerson = customWidgets.buttonSwitchPerson;
exports.segmentsPersonTripsTitle = customWidgets.segmentsPersonTripsTitle;
exports.personVisitedPlacesMap = customWidgets.personVisitedPlacesMap;
exports.personTrips = customWidgets.personTrips;
exports.segmentIntro = customWidgets.segmentIntro;
exports.segments = customWidgets.segments;
exports.segmentSameModeAsReverseTrip = customWidgets.segmentSameModeAsReverseTrip;
exports.segmentModePre = customWidgets.segmentModePre;
exports.segmentMode = customWidgets.segmentMode;
exports.segmentHowToBus = customWidgets.segmentHowToBus;
exports.segmentPaidForParking = Object.assign(Object.assign({}, defaultInputBase.inputRadioBase), { path: 'paidForParking', twoColumns: false, containsHtml: true, label: (t) => t('segments:paidForParking'), choices: choices.yesNoDontKnow, conditional: customConditionals.isCarDriverAndDestinationWorkCustomConditional, validations: validations.requiredValidation });
exports.segmentVehicleOccupancy = Object.assign(Object.assign({}, defaultInputBase.inputRadioNumberBase), { path: 'vehicleOccupancy', twoColumns: false, containsHtml: true, label: (t) => t('segments:vehicleOccupancy'), valueRange: {
        min: 1,
        max: 5
    }, overMaxAllowed: true, conditional: customConditionals.isSelfDeclaredCarDriverCustomConditional, validations: validations.requiredValidation });
exports.segmentDriver = customWidgets.segmentDriver;
exports.segmentBusLines = customWidgets.segmentBusLines;
exports.segmentBusLinesWarning = customWidgets.segmentBusLinesWarning;
exports.segmentOnDemandType = Object.assign(Object.assign({}, defaultInputBase.inputRadioBase), { path: 'onDemandType', twoColumns: false, containsHtml: true, label: (t) => t('segments:onDemandType'), choices: customChoices.onDemandCustomChoices, conditional: customConditionals.shouldDisplayOnDemandTypeCustomConditional, validations: validations.requiredValidation });
exports.tripJunctionQueryString = Object.assign(Object.assign({}, defaultInputBase.inputStringBase), { path: 'tripJunctionQueryString', twoColumns: false, containsHtml: true, label: (t) => t('segments:tripJunctionQueryString'), conditional: customConditionals.shouldAskTripJunctionCustomConditional, validations: validations.optionalValidation });
exports.tripJunctionGeography = customWidgets.tripJunctionGeography;
exports.segmentHasNextMode = customWidgets.segmentHasNextMode;
exports.buttonSaveTrip = customWidgets.buttonSaveTrip;
exports.buttonConfirmNextSection = customWidgets.buttonConfirmNextSection;
